
//Importar helper de autenticación de permisos de rutas.
import { hasPermission } from "./storage";

//Función para extraer los íconos que debe de tener el sidebar de acuerdo con los permisos.
export const iconSidebar = () => {
    let permisos = {
        chats: false,
        remates: false,
        usuarios: false,
        config: false,
      };
            
      hasPermission('/Chats') !== null ? permisos.chats = true : permisos.chats = false ; 
      hasPermission('/Configuracion') !== null ? permisos.config = true  : permisos.config = false ; 
      hasPermission('/Usuarios') !== null ? permisos.usuarios = true  : permisos.usuarios = false ; 
      hasPermission('/Remates') !== null ? permisos.remates = true  : permisos.remates = false; 
  
      return permisos;
};

